module.exports = __webpack_public_path__ + "static/cps-59769c9f6376ac329b1477c4d393a2ce.png";